import { render } from "./HomepageAbout.vue?vue&type=template&id=2c78c7f2"
import script from "./HomepageAbout.vue?vue&type=script&lang=js"
export * from "./HomepageAbout.vue?vue&type=script&lang=js"

import exportComponent from "/home/circleci/project/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__